import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type PaymentResultState = 'success' | 'failed' | 'error';

export interface PaymentResultAction {
  labelKey: string;
  onClick: () => void;
  cssClass?: string;
}

@Component({
  selector: 'app-payment-result-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './payment-result-card.component.html',
  styleUrl: './payment-result-card.component.scss'
})
export class PaymentResultCardComponent {
  @Input() state: PaymentResultState = 'success';

  @Input() successTitleKey = 'SUBSCRIPTION_FLOW.PAYMENT_SUCCESSFUL';
  @Input() successDescriptionKey = 'SUBSCRIPTION_FLOW.PAYMENT_SUCCESSFUL_DESCRIPTION';
  @Input() successDescriptionParams: Record<string, string> = {};
  @Input() failedTitleKey = 'SUBSCRIPTION_FLOW.PAYMENT_FAILED';
  @Input() failedDescriptionKey = 'SUBSCRIPTION_FLOW.PAYMENT_FAILED_DESCRIPTION';
  @Input() errorTitleKey = 'SUBSCRIPTION_FLOW.ERROR_OCCURRED';
  @Input() errorDescriptionKey = 'SUBSCRIPTION_FLOW.ERROR_OCCURRED_DESCRIPTION';

  @Input() actions: PaymentResultAction[] = [];

  get titleKey(): string {
    switch (this.state) {
      case 'failed':
        return this.failedTitleKey;
      case 'error':
        return this.errorTitleKey;
      case 'success':
      default:
        return this.successTitleKey;
    }
  }

  get descriptionKey(): string {
    switch (this.state) {
      case 'failed':
        return this.failedDescriptionKey;
      case 'error':
        return this.errorDescriptionKey;
      case 'success':
      default:
        return this.successDescriptionKey;
    }
  }

  get iconPath(): string {
    if (this.state === 'success') {
      return 'assets/images/icons/2-check.svg';
    }
    return 'assets/images/icons/error.svg';
  }
}
